<template>
  <div
    class="md:container mx-auto flex flex-col items-center font-Almarai relative overflow-x-hidden"
  >
    <LogoSvg class="absolute" />

    <div class="flex justify-center items-center w-3/12 mt-4 h-36">
      <img src="@/assets/logo-1.webp" alt="logo" class="w-28" />
    </div>
    <!-- Main Content -->
    <div
      class="flex flex-col justify-center items-center gap-y-6 bg-transparent rounded-md md:mx-auto mx-2 md:w-6/12 w-full px-2"
    >
      <div class="my-2 flex flex-col justify-center items-center w-full">
        <h1 class="md:text-2xl font-bold text-white my-2 font-Almarai">
          اختر الباقة المناسبة
        </h1>

        <!-- stripe plans -->
        <div
          class="flex flex-col col-span-5 gap-y-4 justify-center items-center py-4 rounded-md w-full"
        >
         

          <monthly-option
            v-for="(price,index) in prices"
            :key="index"
            @click="selectPlan(price.metadata.name)"
            :isSelected="isSelected"
            class="cursor-pointer"
            :price="price"
          />
        </div>

        <!-- end of monthly -->

        <!-- end of stripe plans -->
      </div>
      <div class="flex flex-col items-center gap-y-2 justify-center w-full mx-auto my-3">
        <button
          @click.prevent="redirectUserToProvider"
          class="inline-flex justify-center items-center gap-2 md:w-10/12 w-full bg-[#9d2890] text-gray-100 rounded-md py-3"
        >
          <span> متابعة </span>
        </button>
        <button
          @click.prevent="$router.go(-1)"
          class="inline-flex justify-center items-center gap-2 md:w-10/12 w-full border border-basic text-gray-100 rounded-md py-3"
        >
          <span> رجوع </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
import animationData from "@/assets/loader.json";
import LogoSvg from "@/components/svg/LogoSvg.vue";

import MonthlyOption from "@/components/payments/MonthlyOption.vue";

export default {
  components: {
    LogoSvg,
    MonthlyOption,
  },
  data() {
    return {
      toast: useToast(),
      loaded: false,
      lottieOptions: {
        animationData,
        loop: true,
        autoplay: true,
      },
      jsonFile: animationData,

      prices: [
        {
          metadata: {
            name: "daily",
            title: "يومياً",
            price: 200,
          },
        },
        
        {
          metadata: {
            name: "weekly",
            title: "أسبوعياً",
            price: 700,
          },
        },
        {
          metadata: {
            name: "monthly",
            title: "شهرياً",
            price: 1500,
          },
        },
      ], // List of prices fetched from the backend

      isMobile: false,
      selectedProvider: null,
      StripePlan: null,
      isSelected: null,
      activeTab: "mobile",
      monthlyPlan: null,
      yearlyPlan: null,
      countryCode: false,
    };
  },
  computed: {
    isCodeFull() {
      return this.code.length === 4; // Assuming OTP is 6 digits long
    },
  },
  methods: {
    selectPlan(name) {
      this.isSelected = name;
      console.log("selected", this.isSelected);
    },
    redirectUserToProvider() {
      if (!this.isSelected) {
        this.toast.error("اختر الباقة المناسبة");
        return;
      }
     
        localStorage.setItem("selectedPrice", this.isSelected);
        this.$router.push({ name: "subscribe", params: {} });
      }
    },
   
  


  
 
};
</script>

<style scoped>
/* Your existing styles */
</style>

<style scoped></style>
